import React from 'react';
import { MetaTags } from 'react-meta-tags';
import {Breadcrumbs,DashBreadcrumb,
} from '../../components/Common/Breadcrumb';
import ReturnStoreList from './components/ReturnStoreList';
import 'react-datepicker/dist/react-datepicker.css';
import 'flatpickr/dist/themes/material_blue.css';
import Flatpickr from 'react-flatpickr';

import { Col, Container, Row, FormGroup, InputGroup } from 'reactstrap';
import ReturnStoreExportReport from '../Returns/components/ReturnExportReport';
import { EXPORT_ALLOWED_USER_ROLES } from '../../constants';

const ReturnStoreIndex = () => {
  const title = 'Stores';
  const description = 'Manage Store Returns';
  const users = JSON.parse(localStorage?.getItem('authUser'));
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Store Returns</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb
                title="Stores"
                breadcrumbItem="Manage Store Returns" 
              />
            </Col>
            <Col className="textAlignRight ">
              <a href={`/CreateFormStoreReturn`} className="btn btn-dark">
                Create New Store Return
              </a>
            </Col>
            <Col>
              {EXPORT_ALLOWED_USER_ROLES.includes(users?.role_id) ? (
                <ReturnStoreExportReport users={users} />
              ) : (
                ''
              )}
            </Col>
          </Row>
          <ReturnStoreList /> 
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReturnStoreIndex;
